import axios from "../axios";

const create = (data) => {
  return axios
    .post(`/share-capital-allotment`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response) {
        console.error("Server response:", error.response);
      }
      throw error;
    });
};

const update = (shareAllotmentId, data) => {
  return axios.put(`/share-capital-allotment/${shareAllotmentId}`, data);
};

const remove = (id) => {
  return axios.delete(`/share-capital-allotment/${id}`);
};

const getList = (companyId) => {
  return axios
    .get(`/share-capital-allotment?companyId=${companyId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const submitAllotments = (data) => {
  return axios.post(
    `/share-capital-allotment/submit-share-capital-allotment`,
    data
  );
};
const createRightsIssue = (data) => {
  return axios
    .post(`/share-capital-allotment/rights-issue`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response) {
        console.error("Server response:", error.response);
      }
      throw error;
    });
};

const createGeneralOffer = (data) => {
  return axios
    .post(`/share-capital-allotment/general-offer`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response) {
        console.error("Server response:", error.response);
      }
      throw error;
    });
};
const createProRata = (data) => {
  return axios
    .post(`/share-capital-allotment/pro-rata`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response) {
        console.error("Server response:", error.response);
      }
      throw error;
    });
};

const shareAllotmentDataService = {
  create,
  update,
  remove,
  getList,
  submitAllotments,
  createProRata,
  createRightsIssue,
  createGeneralOffer,
};

export default shareAllotmentDataService;
